// Product page functionality: image carousel, variant selection, quantity controls

class ProductPage {
    constructor(container) {
        this.container = container;
        this.productForm = container.querySelector('product-form');
        this.sliderTrack = container.querySelector('[data-slider-track]');
        this.thumbnails = container.querySelectorAll('.product__media-thumbnail');
        this.currentMediaIndex = 0;

        if (this.container) {
            this.init();
        }
    }

    init() {
        // Initialize image carousel
        this.initMediaCarousel();

        // Initialize zoom effect
        this.initImageZoom();

        // Quantity controls
        this.initQuantityControls();

        // Form submission is handled by product-form.js custom element
    }

    initImageZoom() {
        const zoomContainers = this.container.querySelectorAll('.product__media-item');

        zoomContainers.forEach(container => {
            const image = container.querySelector('.zoomable-image');
            if (!image) return;

            container.addEventListener('mousemove', (e) => {
                const { left, top, width, height } = container.getBoundingClientRect();
                const x = ((e.pageX - window.scrollX - left) / width) * 100;
                const y = ((e.pageY - window.scrollY - top) / height) * 100;

                image.style.transformOrigin = `${x}% ${y}%`;
                if (!image.classList.contains('is-zoomed')) {
                    image.classList.add('is-zoomed');
                }
            });

            container.addEventListener('mouseleave', () => {
                image.classList.remove('is-zoomed');
                image.style.transformOrigin = 'center center';
            });
        });
    }

    initMediaCarousel() {
        const prevButton = this.container.querySelector('.product__media-arrow--prev');
        const nextButton = this.container.querySelector('.product__media-arrow--next');

        if (!this.thumbnails.length || !this.sliderTrack) return;

        // Thumbnail clicks
        this.thumbnails.forEach((thumbnail, index) => {
            thumbnail.addEventListener('click', () => {
                this.changeMedia(index);
            });
        });

        // Arrow navigation
        if (prevButton) {
            prevButton.addEventListener('click', () => {
                const newIndex = this.currentMediaIndex - 1 < 0
                    ? this.thumbnails.length - 1
                    : this.currentMediaIndex - 1;
                this.changeMedia(newIndex);
            });
        }

        if (nextButton) {
            nextButton.addEventListener('click', () => {
                const newIndex = this.currentMediaIndex + 1 >= this.thumbnails.length
                    ? 0
                    : this.currentMediaIndex + 1;
                this.changeMedia(newIndex);
            });
        }
    }

    changeMedia(index) {
        if (!this.thumbnails[index] || !this.sliderTrack) return;

        this.currentMediaIndex = index;

        // Update active thumbnail
        this.thumbnails.forEach(thumb => thumb.classList.remove('active'));
        this.thumbnails[index].classList.add('active');

        // Update active media item
        const mediaItems = this.sliderTrack.querySelectorAll('.product__media-item');
        mediaItems.forEach(item => item.classList.remove('active'));
        if (mediaItems[index]) mediaItems[index].classList.add('active');

        // Move slider track
        const offset = -index * 100;
        this.sliderTrack.style.transform = `translateX(${offset}%)`;
    }

    initQuantityControls() {
        const quantityInput = this.container.querySelector('.quantity-input');
        const minusButton = this.container.querySelector('.quantity-button--minus');
        const plusButton = this.container.querySelector('.quantity-button--plus');

        if (!quantityInput) return;

        minusButton?.addEventListener('click', () => {
            const currentValue = parseInt(quantityInput.value);
            if (currentValue > 1) {
                quantityInput.value = currentValue - 1;
                quantityInput.dispatchEvent(new Event('change'));
            }
        });

        plusButton?.addEventListener('click', () => {
            const currentValue = parseInt(quantityInput.value);
            quantityInput.value = currentValue + 1;
            quantityInput.dispatchEvent(new Event('change'));
        });

        // Validate input
        quantityInput.addEventListener('change', () => {
            let value = parseInt(quantityInput.value);
            if (isNaN(value) || value < 1) {
                quantityInput.value = 1;
            }
        });
    }

    // REMOVED: Form submission is handled by product-form.js custom element
    // This was causing duplicate submissions and adding 2 items instead of 1
    /*
    initFormSubmit() {
        const form = this.container.querySelector('form[action*="/cart/add"]');
        if (!form) return;

        form.addEventListener('submit', async (e) => {
            e.preventDefault();

            const submitButton = form.querySelector('[type="submit"][name="add"]');
            if (submitButton) {
                submitButton.setAttribute('disabled', true);
                submitButton.classList.add('loading');
            }

            const formData = new FormData(form);
            const config = {
                method: 'POST',
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                    'Accept': 'application/javascript'
                },
                body: formData
            };

            try {
                const response = await fetch('/cart/add.js', config);
                const responseData = await response.json();

                if (responseData.status) {
                    // Error handling
                    console.error('Error adding to cart:', responseData.description);
                    if (submitButton) {
                        submitButton.classList.remove('loading');
                        submitButton.removeAttribute('disabled');
                        // Optional: Show error message to user
                        alert(responseData.description);
                    }
                    return;
                }

                // Success
                if (submitButton) {
                    submitButton.classList.remove('loading');
                    submitButton.removeAttribute('disabled');
                }

                // Dispatch global event to update cart drawer
                document.dispatchEvent(new Event('cart:updated'));

            } catch (error) {
                console.error('Error:', error);
                if (submitButton) {
                    submitButton.classList.remove('loading');
                    submitButton.removeAttribute('disabled');
                }
            }
        });
    }
    */
}

// Initialize all product sections on the page
document.addEventListener('DOMContentLoaded', () => {
    const productSections = document.querySelectorAll('.product-section');
    productSections.forEach(section => new ProductPage(section));
});
